import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "About", href: "#speaker" },
  { label: "Programme", href: "#agenda" },
  { label: "Organisers", href: "#organisers" },
  { label: "Why Attend", href: "#why-attend" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, [setScrolled]); // setScrolled is stable (useState setter)

  const scrollTo = (href) => {
    setMobileOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-[#050C1C]/95 backdrop-blur-xl shadow-lg shadow-black/30" : "bg-transparent"
      } border-b border-[#D4AF37]/10`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        {/* Logo */}
        <div data-testid="navbar-logo" className="flex items-center">
          <img
            src="https://customer-assets.emergentagent.com/job_elite-policy-summit/artifacts/v7azwox2_Digpu%20Original%20Logo%20.png"
            alt="Digpu News & Media"
            className="h-9 w-auto object-contain"
            style={{ filter: "brightness(1.05)" }}
          />
        </div>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button key={link.href} onClick={() => scrollTo(link.href)} className="nav-link" data-testid={`nav-${link.label.toLowerCase()}`}>
              {link.label}
            </button>
          ))}
        </div>

        {/* CTA */}
        <button
          data-testid="nav-register-btn"
          onClick={() => scrollTo("#register")}
          className="hidden md:flex btn-gold text-xs"
        >
          Request Invitation
        </button>

        {/* Mobile toggle */}
        <button data-testid="mobile-menu-toggle" className="md:hidden text-white" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#050C1C]/98 backdrop-blur-xl border-t border-[#D4AF37]/10 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <button key={link.href} onClick={() => scrollTo(link.href)} className="nav-link text-left" data-testid={`mobile-nav-${link.label.toLowerCase()}`}>
              {link.label}
            </button>
          ))}
          <button data-testid="mobile-register-btn" onClick={() => scrollTo("#register")} className="btn-gold w-full justify-center mt-2">
            Request Invitation
          </button>
        </div>
      )}
    </nav>
  );
}
